import { LabeledValue } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { Stack } from "../../commons/layout/Stack.js";
import { useOrganisationRoles, useProjectRoles } from "./useRoles.js";
import {
  UserRolesBox_UserFragment,
  UserRolesBox_ViewerFragment,
} from "./UserRolesBox.generated.js";

type User = UserRolesBox_UserFragment | UserRolesBox_ViewerFragment;

interface Props {
  user: User;
}

export const UserRolesBox = ({ user }: Props) => {
  const { t } = useTranslate(["UserProfile", "Global"]);

  const { getOrganisationRoleTitle } = useOrganisationRoles();
  const { getProjectRoleTitle } = useProjectRoles();

  const rolesLabel = getOrganisationRoleTitle(user.roles);
  const projectRolesLabel = getProjectRoleTitle(user.defaultProjectRoles);

  return (
    <Stack flexDirection="column">
      <LabeledValue
        label={t("Default project role", {
          ns: "UserProfile",
        })}
      >
        {projectRolesLabel ||
          t("Not set", {
            ns: "Global",
          })}
      </LabeledValue>
      <LabeledValue
        label={t("Organisation role", {
          ns: "UserProfile",
        })}
      >
        {rolesLabel ||
          t("Not set", {
            ns: "Global",
          })}
      </LabeledValue>
    </Stack>
  );
};
